import axios from "axios";
import { USER_INFO_KEY } from "../utils/HelperFunction/Constants";
import { getDecryptedItem } from "../utils/storageUtils";

const axiosInstance = axios.create({ timeout: 30000 });

// Request interceptor: attach Bearer token from localStorage
axiosInstance.interceptors.request.use(
  (config) => {
    const userInfo = getDecryptedItem(USER_INFO_KEY);
    if (userInfo && userInfo.token) {
      config.headers["Authorization"] = `Bearer ${userInfo.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: log 401s and re-throw all errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("[apiClient] 401 Unauthorized:", error.config?.url);
    }
    return Promise.reject(error);
  }
);

const get = (url, params, config) =>
  axiosInstance.get(url, { params, ...config });
const post = (url, data, config) => axiosInstance.post(url, data, config);
const put = (url, data) => axiosInstance.put(url, data);
const remove = (url, data, config) =>
  axiosInstance.delete(url, { data, ...config });
const stream = async (url, data, signal) => {
  const userInfo = getDecryptedItem(USER_INFO_KEY);
  const headers = { "Content-Type": "application/json" };
  if (userInfo?.token) {
    headers["Authorization"] = `Bearer ${userInfo.token}`;
  }
  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
    signal,
  });
  if (!response.ok) {
    throw new Error(`Streaming request failed with status ${response.status}`);
  }
  return response.body;
};

export const apiClient = { get, post, put, delete: remove, stream };
